import React, { createContext, useContext, useMemo, useState } from 'react';

import { Context } from './types/context';
import { RoutesError } from './types/routesError';

import useRoutes from './hooks/useRoutes';
import useActiveRoutes from './hooks/useActiveRoutes';
import useRoutesStations from './hooks/useRoutesStations';

interface Props {
  children: React.ReactNode;
}

export const RoutesContext = createContext({} as Context);
export const useRoutesContext = () => useContext(RoutesContext);

const RoutesProvider = ({ children }: Props) => {
  const [ routesError, setRoutesError ] = useState<RoutesError>();
  const { routes, setRoutes, onChangeRoutes, getRouteById, resetRoutes } = useRoutes(setRoutesError);
  const { activeRoute, setActiveRoute, resetActiveRoute } = useActiveRoutes();
  const { routesStations, setRoutesStations, getRouteStationsById, resetRoutesStations } = useRoutesStations();
  const [ routesStationServicePrices, setRoutesStationServicePrices ] = useState<Context['routesStationServicePrices']>();
  const [ selectedFuel, setSelectedFuel ] = useState<Context['selectedFuel']>();
  const [ visibleStationsByZoom, setVisibleStationsByZoom ] = useState<Context['visibleStationsByZoom']>();

  const value = useMemo(() => ({
    routesError,
    setRoutesError,

    routes,
    setRoutes,
    onChangeRoutes,
    getRouteById,
    resetRoutes,

    activeRoute,
    setActiveRoute,
    resetActiveRoute,

    routesStations,
    hasRoutesStations: !!Object.keys(routesStations).length,
    setRoutesStations,
    getRouteStationsById,
    resetRoutesStations,

    routesStationServicePrices,
    setRoutesStationServicePrices,

    selectedFuel,
    setSelectedFuel,

    visibleStationsByZoom,
    setVisibleStationsByZoom
  }), [
    routesError,
    setRoutesError,

    routes,
    setRoutes,
    onChangeRoutes,
    getRouteById,
    resetRoutes,

    activeRoute,
    setActiveRoute,
    resetActiveRoute,

    routesStations,
    setRoutesStations,
    getRouteStationsById,
    resetRoutesStations,

    routesStationServicePrices,
    setRoutesStationServicePrices,

    selectedFuel,
    setSelectedFuel,

    visibleStationsByZoom,
    setVisibleStationsByZoom
  ]);

  return (
    <RoutesContext.Provider value={value}>{children}</RoutesContext.Provider>
  );
};

export default RoutesProvider;
